import SectionCard from '@components/section-card/SectionCard';
import SectionHeader from '@components/section-header/SectionHeader';
import ExternalLink from '@src/app-components/external-link/ExternalLink';
import ProgressiveImage from '@src/app-components/progressive-image/ProgressiveImage';

const Mitigation = () => (
  <>
    <section id='mitigation-info-id'>
      <SectionHeader>Mitigation Information</SectionHeader>
      <p>
        The overall objective of the Clean Water Act (CWA) is "to restore and maintain the chemical, physical, and
        biological integrity of the Nation's waters." To achieve this goal, the CWA prohibits the discharge of dredged
        or fill material into wetlands, streams, and other waters of the United States unless a permit is issued by the
        U.S. Army Corps of Engineers. During the permit review process, the applicant must demonstrate that he or she
        has avoided and minimized impacts to aquatic resources to the maximum extent practicable. For any remaining
        unavoidable impacts, compensatory mitigation is usually required to replace the loss of wetland, stream, and/or
        other aquatic resource functions. The Corps is responsible for determining the appropriate form and amount of
        compensatory mitigation that may be required. Methods of providing compensatory mitigation include aquatic
        resource restoration, establishment, enhancement, and in certain circumstances, preservation.
      </p>
      <p>
        In accordance with the Final Compensatory Mitigation Rule, the applicant is required to provide a "Mitigation
        Statement" with any application stating how he or she intends to compensate for the loss of aquatic functions or
        why compensatory mitigation should not be required. As the development and implementation of a compensatory
        mitigation project can be beyond the capability of many applicants, the Final Compensatory Mitigation Rule
        expresses a preference for first, obtaining mitigation credits from an established mitigation bank; second,
        purchasing credits from an approved in In-Lieu-Fee program; and lastly, by providing permittee responsible
        mitigation.
      </p>
      <p>
        <ExternalLink href='https://youtu.be/nQ6RxHmczXg'>
          View this video demonstration of how to enter project impacts and mitigation.
        </ExternalLink>
      </p>
      <SectionCard
        title='Final Compensatory Mitigation Rule'
        content='Learn more about the Final Compensatory Mitigation Rule, related documents and resources, and district specific mitigation information.'
        url={'https://www.usace.army.mil/Missions/Civil-Works/Regulatory-Program-and-Permits/mitig_info/'}
        buttonText='Mitigation Rule'
        buttonTitle='MitigationRule'
        external
      />
    </section>

    <section id='ribits-id' className='margin-top-3'>
      <SectionHeader>Regulatory in Lieu Fee and Bank Information Tracking System (RIBITS)</SectionHeader>
      <p>
        RIBITS was developed by the U.S. Army Corps of Engineers to track mitigation banking and in-lieu fee (ILF)
        program activities across the United States. RIBITS includes information regarding banks and ILF program sites,
        associated documents, mitigation credit availability, service areas, and policies and procedures that affect
        bank and ILF program development and operation.
      </p>
      <p>
        With support from the U. S. Environmental Protection Agency, U. S. Fish and Wildlife Service, NOAA-National
        Marine Fisheries Service (NOAA-NMFS), and Federal Highway Administration, RIBITS has grown to include
        conservation banking and multi-agency banking activities. Support from the U. S. Department of Agriculture
        allows RIBITS to track water-quality trading activities in multiple states, with pilot projects in the states of
        Virginia and Iowa, and additional support from NOAA-NMFS allows RIBITS to track credits for restoration banks
        recognized under Natural Resource Damage Assessment statutes.
      </p>
      <p>
        Upcoming modifications include a mitigation banking module for RIBITS newest partner agency, the Bureau of Land
        Management. Hosted by CWBI (Civil Works Business Intelligence).
      </p>
      <div className='grid-row grid-gap-2'>
        <div className='grid-col-4'>
          <ProgressiveImage
            localPath='request-graphics/icon-RIBITS.png'
            hasAvif
            hasWebp
            alt='RIBITS icon'
            style={{ width: '100%', height: '200px' }}
          />
        </div>
        <div className='grid-col-8'>
          <SectionCard
            title='RIBITS'
            content='Navigate and explore RIBITS here.'
            url='https://ribits.ops.usace.army.mil/ords/f?p=107:2::::::'
            buttonText='RIBITS'
            buttonTitle='ribits'
            external
          />
        </div>
      </div>
    </section>
  </>
);

export default Mitigation;
